<template>
  <div class="bg-blackly relative text-white">
    <div class="lg:sticky lg:h-screen lg:mt-0 top-0 flex items-center justify-center pt-20">
      <BarText :tag="'h1'" :text="entry.textOverlay" class="xl:absolute fluid-4xl leading-none text-center" />
    </div>
    <div class="team-wrapper gap-x-12 py-l lg:gap-y-0 md:gap-y-16 gap-y-16 lg:grid-cols-12 container relative grid">
      <div
        v-for="(item, index) in entry.teamMembers"
        :key="index"
        class="card relative"
        :class="[putItemClasses(index)]"
      >
        <ParallaxBox :factor="ITEMS_MOVEMENT_FACTORS[index]" :start-breakpoint="1024" class="relative">
          <FixedAspect :ratio="1.2">
            <CldnImg
              v-if="item.image[0]"
              :src="item.image[0].url"
              :alt="item.image[0].title"
              sizes="90vw lg:25vw xl:25vw 2xl:20vw"
              class="max-w-none block w-full select-none"
            />
          </FixedAspect>
          <div
            class="overlay bg-blackly/80 absolute inset-0 flex flex-col justify-between p-6 transition-opacity opacity-0"
          >
            <div v-if="item.quote" class="fluid-base leading-relaxed font-light" v-html="item.quote"></div>
            <div>
              <div v-if="item.memberName" class="fluid-lg leading-tight font-medium" v-html="item.memberName"></div>
              <div
                v-if="item.role"
                class="fluid-base leading-relaxed font-lighttext-br-green font-semibold"
                v-html="item.role"
              ></div>
            </div>
          </div>
        </ParallaxBox>
      </div>
    </div>
    <!-- <div class=" lg:col-span-4 xl:col-span-3 lg:col-start-1 lg:col-start-2 lg:col-start-3 lg:col-start-4 lg:col-start-5 lg:col-start-6 lg:col-start-7 lg:col-start-8 lg:col-start-9 lg:col-start-10 xl:col-start-1 xl:col-start-2 xl:col-start-3 xl:col-start-4 xl:col-start-5 xl:col-start-6 xl:col-start-7 xl:col-start-8 xl:col-start-9 xl:col-start-10"/> -->
  </div>
</template>
<script>
import gql from 'graphql-tag';
import BarText from '@/components/BarText.vue';
import CldnImg from '@/components/CldnImg';
import ParallaxBox from '@/components/common/ParallaxBox';
import FixedAspect from '@/components/common/FixedAspect';

export const AboutTeamPageFragment = gql`
  fragment AboutTeamPageFragment on aboutTeam_Entry {
    title
    textOverlay
    teamMembers {
      ... on member_Entry {
        memberName
        role
        quote
        image {
          url
          title
        }
      }
    }
  }
`;

export default defineNuxtComponent({
  name: 'AboutTeamPage',
  components: { FixedAspect, BarText, CldnImg, ParallaxBox },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ITEMS_MOVEMENT_FACTORS: [100, -50, 20, 80, -60, 60, 40],
      GRID_START_COLS: [1, 10, 2, 8, 1, 7, 3, 6],
    };
  },
  methods: {
    putItemClasses(index) {
      return `lg:col-start-${this.GRID_START_COLS[index % 8]} xl:col-start-${
        this.GRID_START_COLS[index % 8]
      } lg:col-span-4 xl:col-span-3 ${index % 2 === 0 ? `lg:mt-40` : ``}`;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
@media (width >= 1024px) {
  .team-wrapper {
    margin-top: -100vh;
  }
}
.card:hover .overlay {
  @apply opacity-100;
}
</style>
